"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalSaving = exports.Text = exports.Subtotal = exports.CostBreakDownContent = exports.CostBreakdownContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.CostBreakdownContainer = styled_components_1.default.div `
  display: flex;
  justify-content: ${({ isExpired }) => (isExpired ? 'center' : 'flex-end')};
  margin-bottom: ${({ theme }) => theme.space.s150};
`;
exports.CostBreakDownContent = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
exports.Subtotal = styled_components_1.default.div `
  display: flex;
  margin-left: ${({ theme }) => theme.space.s200};

  font-size: 1.25rem;
  font-weight: 600;
`;
exports.Text = styled_components_1.default.div `
  margin-right: 6px;
`;
exports.TotalSaving = styled_components_1.default.div `
  display: flex;

  color: ${({ theme }) => theme.colors.global.green};

  font-weight: 500;
`;
